import wretch from 'wretch'
import { Entity } from '@loctypes/entities'
import { InitialConfig, WidgetConfig } from '@loctypes'

type ConfigQuery = { type: Entity }

export default class CommonAPI {
  static fetchConfig(clientKey: InitialConfig['clientKey'], query: ConfigQuery): Promise<WidgetConfig> {
    return wretch(`${LINKER_SERVICE_URL}/widget/v3/settings/${clientKey}`).query(query).get().json()
  }
}
